import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {TemplatesState} from './types';
import {TemplatesFilterParams} from "@/store/sms/templates/types";

export const actions: ActionTree<TemplatesState, RootState> = {
  getPushTemplates: ({commit, dispatch}, data: TemplatesFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/push/templates',
        params: data,
      })
        .then((resp:any) => {
          commit('setPushTemplates', resp.data.templates);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
};
